module.exports = __webpack_public_path__ + "assets/img/enterIcon8.510a9173.png";